<template>
    <div class="exhibition-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/Welcome' }">
                    <i class="el-icon-s-home"></i>首页
                </el-breadcrumb-item>
                <el-breadcrumb-item><i class="el-icon-s-order"></i>展会列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 主内容卡片 -->
        <el-card class="main-card" shadow="hover">
            <!-- 头部操作区域 -->
            <div class="card-header">
                <div class="header-title">
                    <i class="el-icon-s-data"></i>
                    <span>展会信息管理</span>
                </div>
                <div class="header-actions">
                    <el-button size="small" type="primary" icon="el-icon-circle-plus-outline" @click="addData">
                        新增展会
                    </el-button>
                    <el-button size="small"  icon="el-icon-s-grid" @click="goCategory">
                        分类管理
                    </el-button>
                </div>
            </div>

            <!-- 搜索区域 -->
            <div class="search-container">
                <el-form
                        :inline="true"
                        :model="searchForm"
                        ref="searchForRef"
                        label-width="80px"
                        size="small"
                        class="search-form"
                >
                    <el-form-item label="所属省市">
                        <el-cascader
                                ref="cascaderAddr"
                                style="width: 90%"
                                v-model="areaList"
                                clearable
                                filterable
                                :props="propsdata"
                                :key="isResouceone"
                                @change="handleChangeAddress"
                                placeholder="请选择省市"

                        >
                        </el-cascader>
                    </el-form-item>

                    <el-form-item label="展会标题">
                        <el-input
                                v-model="searchForm.name"
                                placeholder="请输入展会标题"
                                clearable
                                prefix-icon="el-icon-search"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="进行中" value="1"></el-option>
                            <el-option label="已结束" value="2"></el-option>
                            <el-option label="未开始" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small"  type="primary" icon="el-icon-search" @click="searchSubmit">搜索</el-button>
                        <el-button size="small"  icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!-- 数据表格 -->
            <div class="table-container">
                <el-table
                        ref="multipleTable"
                        :data="tableLoadData"
                        stripe
                        border
                        size="mini"
                        v-loading="loading"
                        element-loading-text="数据加载中..."
                        element-loading-spinner="el-icon-loading"
                        :empty-text="emptyText"
                        style="width: 100%"
                >
                    <el-table-column type="index" label="序号" width="70" align="center">
                        <template slot-scope="scope">
                            <span>{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="展会标题"
                            width="400"
                            prop="title"
                            :show-overflow-tooltip='true'
                    >

                    </el-table-column>

                    <el-table-column
                            label="状态"
                            width="150"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div class="title-cell">

                                <el-tag
                                        v-if="scope.row.status === 1"
                                        size="mini"
                                        type="success"
                                        class="status-tag"
                                >进行中</el-tag>
                                <el-tag
                                        v-else-if="scope.row.status === 2"
                                        size="mini"
                                        type="info"
                                        class="status-tag"
                                >已结束</el-tag>
                                <el-tag
                                        v-else
                                        size="mini"
                                        type="warning"
                                        class="status-tag"
                                >未开始</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="所属分类"
                            width="150"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <el-tag size="mini" type="text"  v-if="scope.row.category">
                                {{ scope.row.category.name }}
                            </el-tag>
                            <span v-else class="empty-text"  style="font-size:14px">未分类</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="所属商家"
                            width="150"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.shop">{{ scope.row.shop.name }}</span>
                            <span v-else class="empty-text">未指定</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="发布日期"
                            width="180"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <span>{{ scope.row.add_time | dateFormat }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="操作"
                            width="180"
                            fixed="right"
                            align="center"
                    >
                        <template slot-scope="scope">
                            <div class="action-buttons">
                                <el-button
                                        type="text"
                                        icon="el-icon-edit"
                                        size="mini"
                                        @click="handleClick(scope.row)"
                                        plain
                                >编辑</el-button>
                                <el-button
                                        type="text"
                                        icon="el-icon-delete"
                                        size="mini"
                                        @click="del(scope.row)"
                                        plain
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                >
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
    import moment from 'moment'
    import axios from "axios";     //日期时间转换
    export default {
        name: "expoList",
        components: {},
        props: {},
        data() {
            return {
                areaList:[],
                isResouceone: false,
                propsdata: {
                    // 懒加载地区列表
                    checkStrictly: true,
                    lazy: true,
                    lazyLoad(node, resolve) {
                        // const { level } = node;
                        console.log(node)
                        let url= '/api/api/cmp.sys.Region_read_lz/findRegionList';
                        setTimeout(() => {
                            // 第一級
                            if (node.level == 0) {
                                // Ajax請求數據，填充選擇框
                                // 接口请求获取省份
                                //  var _this=this;

                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:1
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                            //  leaf: node.children >= 1,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                            // 第二級
                            if (node.level == 1) {
                                // Ajax請求數據，填充選擇框
                                // 接口请求获取省份
                                // var _this=this;
                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:node.value
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                            // leaf: node.children >= 1,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                            if (node.level == 2) {
                                // Ajax請求數據，填充選擇框
                                // // 接口请求获取省份
                                axios.post(url,{
                                    access_token:sessionStorage.getItem('token'),
                                    company_id:sessionStorage.getItem('company_id'),
                                    parent_id:node.value
                                }).then((res)=>{
                                    if(res.data.code==200){
                                        const nodes = res.data.data.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                            leaf: true,
                                        }));
                                        resolve(nodes);
                                    }
                                }).catch(function(){
                                });
                            }
                        }, 100);
                    },
                },
                // 搜索
                searchForm: {
                    name: "",
                    shop_id:'',
                    keyword:'',
                    province_id:'',
                    city_id:'',
                    district_id:'',
                    status:''
                },
                // 表格数据
                tableLoadData: [],
                loading: false,
                emptyText: "暂无数据",

                // 分页
                pageNum: 1,
                pageSize: 10,
                total: 0,

                showType: '',
            };
        },
        created() {
            this.showType = this.$route.query.showType;
            this.DataList();
        },
        filters: {
            // 时间格式化
            dateFormat(add_time) {
                if (!add_time) return "";
                return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
            }
        },
        methods: {
            handleChangeAddress(){

            },
            // 跳转到编辑页面
            handleClick(row) {
                this.$router.push('/expoForm?id=' + row.id)
            },

            // 跳转到分类管理
            goCategory() {
                this.$router.push('/newsCategory')
            },

            // 获取展会列表
            DataList() {
                this.loading = true;
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    showType: this.showType,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    parent_id: sessionStorage.getItem('shop_id'),
                    title: this.searchForm.name,
                    status: this.searchForm.status
                }
                console.log('param------',param)
                this.$axios.findExpoListP(param).then(res => {
                    console.log('res------',res)
                    this.loading = false;
                    if (res.code == 200) {
                        this.tableLoadData = res.data.data || [];
                        this.total = res.data.total || 0;

                        // 如果没有数据，显示提示信息
                        if (this.tableLoadData.length === 0) {
                            this.emptyText = "暂无展会数据";
                        }
                    } else {
                        this.$message.error(res.msg || "获取数据失败");
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                    this.$message.error("网络错误，请稍后重试");
                })
            },

            // 设置每页条数
            handleSizeChange(newSize) {
                this.pageSize = newSize;
                this.pageNum = 1;
                this.DataList();
            },

            // 分页跳转
            handleCurrentChange(newPage) {
                this.pageNum = newPage;
                this.DataList();
            },

            // 新增展会
            addData() {
                this.$router.push({
                    name:'expoForm'
                });
            },

            // 搜索
            searchSubmit() {
                this.pageNum = 1;
                this.DataList();
            },

            // 重置搜索
            resetSearch() {
                this.searchForm = {
                    name: "",
                    status: ""
                };
                this.pageNum = 1;
                this.DataList();
            },

            // 删除展会
            del(e) {
                this.$confirm('确定要删除该展会吗？', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    const param = {
                        operator_id: sessionStorage.getItem('user_id'),
                        company_id: sessionStorage.getItem('company_id'),
                        access_token: sessionStorage.getItem('token'),
                        id: e.id,
                    }

                    this.$axios.newsDel(param).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.pageNum = 1;
                            this.DataList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(error => {
                        console.log(error);
                        this.$message.error("删除失败，请稍后重试");
                    });
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
            }
        }
    };
</script>

<style scoped>
    .exhibition-container {
        padding: 20px;
        background-color: #f5f7fa;
        min-height: calc(100vh - 84px);
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    .main-card {
        border-radius: 8px;
        border: none;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebeef5;
        margin-bottom: 20px;
    }

    .header-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }

    .header-title i {
        margin-right: 8px;
        color: #409EFF;
    }

    .search-container {
        margin-bottom: 20px;
    }

    .search-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .table-container {
        margin-bottom: 20px;
    }

    .title-cell {
        display: flex;
        align-items: center;
    }

    .title-text {
        flex: 1;
        margin-right: 8px;
    }

    .status-tag {
        flex-shrink: 0;
    }

    .empty-text {
        color: #909399;
        font-style: italic;
    }

    .action-buttons {
        display: flex;
        justify-content: center;
        gap: 8px;
    }

    .pagination-container {
        display: flex;
        justify-content: flex-end;
    }

    /* 响应式调整 */
    @media (max-width: 768px) {
        .exhibition-container {
            padding: 10px;
        }

        .card-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .header-actions {
            margin-top: 10px;
        }

        .search-form {
            flex-direction: column;
            align-items: flex-start;
        }

        .search-form .el-form-item {
            margin-right: 0;
            margin-bottom: 10px;
            width: 100%;
        }

        .action-buttons {
            flex-direction: column;
            gap: 5px;
        }

        .action-buttons .el-button {
            width: 100%;
        }
    }
</style>
